import { getSupportedCountryList } from "./FirmTypes";
//Mode for the regie data selection.
export const DATA_SELECTEN_MODE_CHRONICAL = 1;
export const DATA_SELECTEN_MODE_SUMMARIZED = 2;
export const DATA_SELECTEN_MODE_NO_DETAIL = 3;
export const PLACEHOLDER = "..........";
export const IMAGE_PLACEHOLDER_URL = "https://enzianimages.s3.eu-central-2.amazonaws.com/placeholder_image.png";
export function convertPrintAddressToPrintText(printAddress, configPage) {
    let texts = [];
    if (printAddress.partenrNr) {
        let partenrNr = printAddress.partenrNr;
        if (!printAddress.relation) {
            partenrNr += "\n";
        }
        texts.push({
            text: partenrNr,
            newLine: true
        });
    }
    if (printAddress.relation) {
        texts.push({
            text: printAddress.relation + "\n",
            font: configPage.defaultFontBold,
            fontSize: configPage.defaultBoldFontSize,
            underline: true,
            newLine: true
        });
    }
    let value = "";
    if (printAddress.firmOrTitle) {
        value += printAddress.firmOrTitle + "\n";
    }
    if (printAddress.titleFirstNameName) {
        value += printAddress.titleFirstNameName + "\n";
    }
    if (printAddress.addon) {
        value += printAddress.addon + "\n";
    }
    if (printAddress.streetOne) {
        value += printAddress.streetOne + "\n";
    }
    if (printAddress.streetSecond) {
        value += printAddress.streetSecond + "\n";
    }
    if (printAddress.zipPlace) {
        value += printAddress.zipPlace + "\n";
    }
    if (printAddress.countryCode != "CH") {
        const countries = getSupportedCountryList();
        const foundCountry = countries.find((it) => it.value == printAddress.countryCode);
        if (foundCountry) {
            value += foundCountry.postalName.toUpperCase();
        }
    }
    //Add the rest to the print array
    texts.push({ text: value, newLine: true, fontSize: configPage.defaultBoldFontSize });
    return {
        x: printAddress.x,
        y: printAddress.y,
        isPrint: printAddress.isPrint,
        spacingY: null,
        values: texts,
        type: "PrintText"
    };
}
/**
 * Calcualte the start and the end of a line for the given cols.
 * @param tableStart
 * @param colStart
 * @param colEnd
 * @param cols
 * @param rowSpacingX
 * @returns
 */
export function getLineStartAndEndForCol(tableStart, colStart, colEnd, cols, rowSpacingX) {
    let endX = tableStart;
    let startX = tableStart;
    for (let i = 0; i < cols.length; i++) {
        if (i < colStart) {
            startX += rowSpacingX + cols[i].width;
        }
        if (i < colEnd) {
            endX += rowSpacingX;
        }
        if (i <= colEnd) {
            //Add the width for the full table calc.
            endX += cols[i].width;
        }
    }
    return [startX, endX];
}
/**
 * Map the vat group to a string key: A, B ,C
 * @param vatGroup
 */
export function getVatAsPrintString(vatGroup) {
    switch (vatGroup) {
        case 1: return "B";
        case 2: return "C";
        default: return "A";
    }
}
